module.exports = __webpack_public_path__ + "img/platform-4.577b56b5.png";